// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"hamburger"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M4 10C4 5.58172 7.58173 3 12 3C16.4183 3 20 5.58172 20 10H4Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M4 18H20C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M4 10C4 5.58172 7.58173 3 12 3C16.4183 3 20 5.58172 20 10H4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M4 18H20C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 15L6 13L9 15L12 13L15 15L18 13L21 15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const HamburgerIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'hamburger',
    ref,
    icon: element,
  },
));

HamburgerIcon.displayName = 'HamburgerIcon';

export default HamburgerIcon;
